import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCustomer } from '../context/CustomerContext';

export default function ProtectedRoute({ children }) {
  const { isVendorAuthenticated, sessionChecked } = useCustomer();
  const navigate = useNavigate();

  useEffect(() => {
    // Ne rediriger que si la session a été vérifiée ET que l'utilisateur n'est pas authentifié
    if (sessionChecked && !isVendorAuthenticated) {
      navigate('/team-lpe');
    }
  }, [sessionChecked, isVendorAuthenticated, navigate]);

  // Afficher un loader pendant la vérification de session
  if (!sessionChecked) {
    return (
      <div className="min-h-screen overflow-x-hidden overflow-y-auto bg-[#030308] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-cyan-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!isVendorAuthenticated) {
    return null;
  }

  return <>{children}</>;
}
